import type { World } from "./WorldState.ts";

export function invariantHas<T extends World.AnyComponentClass>(
  object: Record<string, unknown>,
  component: T,
  message: string,
  found?: unknown,
): asserts object is Record<T["key"], T["Type"]> {
  if (!object[component.key]) {
    console.error(
      `Entity does not contain component (${component.key})`,
      message,
      ...(found ? ["\nFound:", found] : []),
    );
    throw new Error(message + "\n" + JSON.stringify(found, null, 2));
  }
}
